import * as React from 'react';

import moment, { Moment } from 'moment';

export const dateTimeFormatString = 'MM/DD/YYYY h:mm A';
export const dateFormatString = 'MM/DD/YYYY';

export const dateToUtc = (date): Moment => {
	const isGlobalDst = moment(new Date()).isDST();
	const isCurrentDateDst = moment(date).isDST();
	const offset = moment().utcOffset();

	const correctlyOffset = isGlobalDst
		? isCurrentDateDst ? offset : offset - 60
		: isCurrentDateDst ? offset + 60 : offset;
	const momentDate = moment(date);

	// isDST = false - date < 14.03.21, isDST = true - date >= 14.03.21
	return momentDate.subtract(correctlyOffset, 'minutes');
};

export const dateToUtcString = (date, format): string => {
	const utc = dateToUtc(date);
	return moment(utc).format(format);
};

export const longZipFormat = (zip: string | null | undefined): string => zip ? zip.replace(/^(\d{5})(\d{4})$/, '$1 - $2') : '';

export const phoneWithoutAreaCodeFormat = (phone: string): string => phone
	? phone.replace(/^(?:\+[1-9])?(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3') : '';

export enum DashboardTimeInterval {
	All = 0,
	Year = 1,
	Month = 2,
	Week = 3,
	Day = 4,
	Quarter = 5
}

export const intervals = [
	{ caption: 'Day', interval: DashboardTimeInterval.Day },
	{ caption: 'Week', interval: DashboardTimeInterval.Week },
	{ caption: 'Month', interval: DashboardTimeInterval.Month },
	{ caption: 'Quarter', interval: DashboardTimeInterval.Quarter },
	{ caption: 'Year', interval: DashboardTimeInterval.Year },
	{ caption: 'All', interval: DashboardTimeInterval.All }
];

export const tripleVarGroup = [
	{caption: 'Yes', value: true},
	{caption: 'No', value: false},
	{caption: 'All', value: null},
];

export const getMoneyString = (value: number, currencyPrefix = '$') => {
	return `${currencyPrefix}${value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
};